var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.notificacion}},[_vm._v("Enviar Notificacion")])}
var staticRenderFns = []

export { render, staticRenderFns }